import { render } from "./HeaderLogo.vue?vue&type=template&id=40dc3664&scoped=true&bindings={}"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts"

import "./HeaderLogo.vue?vue&type=style&index=0&id=40dc3664&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40dc3664"

export default script